module.exports = __webpack_public_path__ + "img/planting_01.3867c8b.jpg";